import { render } from "./QnaResult.vue?vue&type=template&id=6727f8bf&scoped=true"
import script from "./QnaResult.vue?vue&type=script&lang=js"
export * from "./QnaResult.vue?vue&type=script&lang=js"

import "./QnaResult.vue?vue&type=style&index=0&id=6727f8bf&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6727f8bf"]])

export default __exports__